<template>
  <div class="question">
    <div class="main-container">
      <section class="app-main">
        <div
            id="container"
            class="container"
            :class="{
            container_full: isFullscreen,
          }"
            ref="container"
        >
          <div class="main-background">
            <!-- <img
            v-if="topic[activeKey]['choose']['type'] == 'check' || topic[activeKey]['choose']['type'] == 'radio'"
              style="width: 100%; height: 100%; object-fit: cover"
              :src="question['bg_img']"
            /> -->
            <img
                v-if="
                topic[activeKey]['choose']['type'] == 'check' ||
                topic[activeKey]['choose']['type'] == 'radio' ||
                topic[activeKey]['choose']['type'] == 'check_radio'
              "
                style="width: 100%; height: 100%; object-fit: cover"
                :src="topic[activeKey]['bg_img']"
            />
            <img
                v-if="topic[activeKey]['type'] == 'check_more'"
                :src="
                topic[activeKey]['choose']['chooseOption'][chooseActiveKey][
                  'scene'
                ].length
                  ? topic[activeKey]['choose']['chooseOption'][chooseActiveKey][
                      'scene'
                    ][sceneActiveKey]['bg_img']
                  : topic[activeKey]['choose']['chooseOption'][chooseActiveKey][
                      'bg_img'
                    ]
              "
                style="width: 100%; height: 100%; object-fit: cover"
            />
          </div>
          <div class="title">
            <span style="font-size: 1.8rem">{{ question["name"] || "-" }}</span>
            <span class="ct">答题倒计时：</span>
            <span>{{ timeLable }}</span>
          </div>

          <radio
              v-if="
              topic[activeKey]['choose']['type'] == 'check' ||
              topic[activeKey]['choose']['type'] == 'radio'
            "
              :topic="topic"
              :activeKey="activeKey"
              :percentage="percentage_method"
              :ckeckList.sync="ckeckList"
              :radio.sync="radio"
              @showKeyWords="showKeyWords"
              @audioChange="audioChange"
          ></radio>

          <checkRadio
              v-if="topic[activeKey]['type'] == 'check_radio'"
              :topic="topic"
              :percentage="percentage_method"
              :activeKey="activeKey"
              :radio.sync="radio"
          ></checkRadio>

          <checkMore
              v-if="topic[activeKey]['type'] == 'check_more'"
              :topic="topic"
              :chooseActiveKey="chooseActiveKey"
              :activeKey="activeKey"
              :percentage="percentage_method"
              :ckeckList.sync="ckeckList"
              :sceneActiveKey="sceneActiveKey"
              @sceneChange="sceneChange"
              @sceneAns="sceneAns"
              @sceneNoneAns="sceneNoneAns"
          ></checkMore>

          <!-- 按钮栏 -->
          <div class="toolbar">
            <div class="toolbar-content">
              <div class="btns">
                <!-- <el-button type="primary tips">提示</el-button> -->

                <div class="right-btn">
                  <el-button
                      type="primary"
                      v-if="topic[activeKey]['type'] == 'check_more'"
                      @click="next"
                      v-show="isShowNext"
                  >下一步</el-button
                  >
                  <el-button
                      type="primary"
                      :disabled="
                      sunmitDisabeld ||
                      (isShowNext && topic[activeKey]['type'] == 'check_more')
                    "
                      @click="onSubmit"
                  >提交</el-button
                  >
                  <el-button type="primary" @click="reset">重做</el-button>
                  <el-button type="primary" @click="goBack">返回</el-button>
                </div>
              </div>
            </div>
          </div>

          <!-- 键盘 -->
          <keyWords
              v-if="topic[activeKey]['keywords']"
              :visible="modalType.keyVisible"
              :keywordOption="topic[activeKey]['keywords']"
              @keyChange="keyChange"
              @handDown="handDown"
              :close="() => (modalType.keyVisible = false)"
          ></keyWords>
          <!-- 消防箱 -->
          <freBox
              :visible="modalType.fireBoxVisible"
              @submit="freBoxSubmit"
              :optionType="modalType.optionType"
              :close="() => (modalType.fireBoxVisible = false)"
              :isCheck="modalType.isCheck"
          ></freBox>
          <!-- 表格 -->
          <tableChart
              :visible="modalType.tableVisible"
              v-if="topic[activeKey]['tableWords']"
              :close="() => (modalType.tableVisible = false)"
          ></tableChart>
          <!-- 消防泵 -->
          <firepump
              :visible="modalType.firepumpVisible"
              :optionLight="topic[activeKey]['light']"
              :close="() => (modalType.firepumpVisible = false)"
          ></firepump>
          <!-- 消防总线 -->
          <operaBus
              :keywordOption="topic[activeKey]['keywords']"
              :close="() => (modalType.busxVisible = false)"
              :visible="modalType.busxVisible"
              :disabled="operaBusDis"
              :operaBusFn="
              () => {
                topic[activeKey]['operaBusFn'] &&
                  topic[activeKey]['operaBusFn']();
              }
            "
          ></operaBus>
          <!-- 末端试水装置 -->
          <enddevice :visible="modalType.enddeviceVisible"></enddevice>

          <div class="fullscreen" v-if="!isFullscreen" @click="fullscreenClick">进入全屏</div>
        </div>
      </section>
    </div>

    <!-- <audio v-show="false" ref="submitAudio" controls src="../assets/audio/1-1火警声.mp3" preload="metadata">
    </audio> -->
  </div>
</template>

<script>
import keyWords from "@/components/keyWords.vue";
import tableChart from "@/components/tableChart.vue";
import freBox from "@/components/freBox.vue";
import firepump from "@/components/firepump.vue";
import operaBus from "@/components/operaBus.vue";
import enddevice from "@/components/enddevice.vue";

import { arraysAreEqual } from "@/util/arr.js";

import radio from "@/components/radio.vue";
import checkMore from "@/components/checkMore.vue";
import checkRadio from "@/components/check_radio.vue";
import _ from "lodash";
import screenfull from "screenfull";


// 策略模式
let modalType = {
  keyCode: function () {
    this.keyVisible = true;
  },
  table: function () {
    this.tableVisible = true;
  },
  fireBox: function () {
    this.fireBoxVisible = true;
    this.isCheck = false;
    this.optionType = "fireBox";
  },
  fireBox2: function () {
    this.fireBoxVisible = true;
    this.isCheck = true;
    this.optionType = "fireBox";
  },
  dualPowerSwitch: function () {
    this.fireBoxVisible = true;
    this.optionType = "dualPowerSwitch";
    this.isCheck = false;
  },
  valvegroup: function () {
    this.fireBoxVisible = true;
    this.optionType = "valvegroup";
    this.isCheck = false;
  },
  controlValve: function () {
    this.fireBoxVisible = true;
    this.optionType = "controlValve";
    this.isCheck = false;
  },
  waterInlet: function () {
    this.fireBoxVisible = true;
    this.optionType = "waterInlet";
    this.isCheck = false;
  },
  waterOut: function () {
    this.fireBoxVisible = true;
    this.optionType = "waterOut";
    this.isCheck = false;
  },
  waterInletAbnormal: function () {
    this.fireBoxVisible = true;
    this.optionType = "waterInletAbnormal";
    this.isCheck = false;
  },
  waterOutAbnormal: function () {
    this.fireBoxVisible = true;
    this.optionType = "waterOutAbnormal";
    this.isCheck = false;
  },
  enddevice: function () {
    this.enddeviceVisible = true;
  },
  firepump: function () {
    this.firepumpVisible = true;
  },
  operaBus: function () {
    this.busxVisible = true;
  },

  optionType: "fireBox",
  isCheck: false,
  keyVisible: false,
  tableVisible: false,
  fireBoxVisible: false,
  firepumpVisible: false,
  enddeviceVisible: false,
  busxVisible: false,
};

export default {
  data() {
    return {
      dialogVisible: false,
      fullscreenFlag: false,
      question: null,
      // 进度条
      percentage: 0,
      customColor: "#409eff",
      cities: [],
      topic: [],
      ckeckList: [],
      radio: null,
      activeKey: 0,
      // 答案集合
      modalType: _.cloneDeep(modalType),
      ansObj: {},
      isShowNext: true,
      chooseActiveKey: 0, //变异多选题选项
      sceneActiveKey: 0, //场景
      operaBusDis: true,
      isFullscreen: true, // 是否全屏
      sunmitDisabeld: false,
      audio: null,
      type: "viewr",
      count: 0,
      timer: null,
      timeLable: "00:00",
    };
  },
  components: {
    radio,
    checkMore,
    checkRadio,
    keyWords,
    tableChart,
    freBox,
    firepump,
    enddevice,
    operaBus,
  },
  computed: {
    percentage_method() {
      return parseInt(this.percentage * (this.activeKey + 1));
    },
  },
  created() {
    // console.log('created',`@/api/wei${this.$route.query.id}`)
    let { question } = require(`@/api/wei${this.$route.query.id}`);
    this.question = question;
    this.topic = question["topic"];

    this.percentage = 100 / this.topic.length;
    // 全屏
    screenfull.toggle();

    this.type = this.$route.query.type;
    this.count = this.$route.query.count;
    if (this.type != "viewr") {
      this.timeCountSetInterVal();
    }
  },
  mounted() {
    // 监听全屏变化
    screenfull.onchange(() => {
      this.isFullscreen = screenfull.isFullscreen;
    });
    // 监听按键
    window.addEventListener("keydown", this.KeyDown, true);
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.KeyDown, true);
  },
  methods: {
    fullscreenClick(){
      // 全屏
      screenfull.toggle();
    },
    // 计时器
    timeCountSetInterVal() {
      if (this.timer) return;
      this.timer = setInterval(() => {
        this.count = this.count - 1;
        this.fomatTime(this.count);
        if (this.count <= 0) {
          clearInterval(this.timer);
          this.timer = null;

          let ids = sessionStorage.getItem("ids")
              ? JSON.parse(sessionStorage.getItem("ids"))
              : [];
          ids.push(this.$route.query.id);
          sessionStorage.setItem("ids", JSON.stringify(ids));
          window.sessionStorage.setItem("topic", JSON.stringify(this.topic));
          window.sessionStorage.setItem("ansObj", JSON.stringify(this.ansObj));
          this.$router.replace("/result");
          this.reset();
          this.restAll();
        }
      }, 1000);
    },
    fomatTime(totalSeconds) {
      // ?️ 获取完整分钟数
      const minutes = Math.floor(totalSeconds / 60);
      // ?️ 获得剩余的秒数
      const seconds = totalSeconds % 60;
      // ✅ 格式化为 MM:SS
      if (totalSeconds <= 0) {
        this.timeLable = "00:00";
      } else {
        this.timeLable = `${this.padTo2Digits(minutes)}分:${this.padTo2Digits(
            seconds
        )}秒`;
      }
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },
    audioChange(val) {
      if (val == "start") {
        this.sunmitDisabeld = true;
      }
      if (val == "end") {
        this.sunmitDisabeld = false;
      }
    },
    KeyDown(event) {
      if (event.keyCode === 122) {
        // 禁用f11 键盘本身的事件
        event.returnValue = false;
        screenfull.toggle();
      }
    },

    keyChange(val) {
      this.ckeckList = val;
    },
    handDown(val) {
      this.operaBusDis = !val;
      this.topic[this.activeKey]["handDown"] &&
      this.topic[this.activeKey]["handDown"]();
    },

    sceneAns(e) {
      let option = e;
      if (this.ckeckList[this.chooseActiveKey] == e) {
        option = null;
      }
      this.$set(this.ckeckList, this.chooseActiveKey, option);
      // this.radio = option
      // console.log(this.ckeckList)
    },
    sceneNoneAns(e) {
      let ans = this.ckeckList.filter((item) => item == e);
      if (ans.length) {
        this.ckeckList = this.ckeckList.filter((item) => item != e);
      } else {
        this.ckeckList.push(e);
      }
    },
    sceneChange(e) {
      this.sceneActiveKey = e;
    },

    goBack() {
      this.$router.go(-1);
    },
    showKeyWords(type) {
      this.modalType[type]();
    },
    freBoxSubmit(ckeckList) {
      let ans = this.question.topic[this.activeKey]["choose"]["ans"];
      this.ansObj[this.activeKey] = arraysAreEqual(ans, ckeckList);
      // console.log(this.ansObj)
    },
    next() {
      let length = this.topic[this.activeKey]["choose"]["chooseOption"].length;
      this.chooseActiveKey += 1;
      if (length == this.chooseActiveKey + 1) {
        this.isShowNext = false;
        return;
      }
      this.isShowNext = true;
      this.sceneActiveKey = 0;
    },

    onSubmit() {
      // this.audio.play();
      // if (this.activeKey == this.topic.length) return;
      // 多选
      if (
          this.question.topic[this.activeKey]["type"] == "check" ||
          this.question.topic[this.activeKey]["type"] == "check_more"
      ) {
        // if (this.ckeckList.length == 0) return;
        // 判断两个数组全等
        let ans = this.question.topic[this.activeKey]["choose"]["ans"];
        this.ansObj[this.activeKey] = arraysAreEqual(ans, this.ckeckList);
      }
      // 单选
      if (
          this.question.topic[this.activeKey]["type"] == "radio" ||
          this.question.topic[this.activeKey]["type"] == "check_radio"
      ) {
        // if (!this.radio) return;
        let ans = this.question.topic[this.activeKey]["choose"]["ans"];
        this.ansObj[this.activeKey] = ans == this.radio;
      }

      if (this.activeKey < this.question.topic.length - 1) {
        // this.play(this.topic[this.activeKey][["audio"]]); 暂时
        this.activeKey = this.activeKey + 1;
      } else {
        // alert('做完啦')
        let ids = sessionStorage.getItem("ids")
            ? JSON.parse(sessionStorage.getItem("ids"))
            : [];
        ids.push(this.$route.query.id);

        sessionStorage.setItem("ids", JSON.stringify(ids));
        window.sessionStorage.setItem("topic", JSON.stringify(this.topic));
        window.sessionStorage.setItem("ansObj", JSON.stringify(this.ansObj));
        this.$router.replace("/result");
      }
      this.reset();
      this.restAll();
    },
    reset() {
      this.ckeckList = [];
      this.radio = null;
      this.chooseActiveKey = 0; //变异多选题选项
      this.sceneActiveKey = 0; //场景
    },
    restAll() {
      this.sceneActiveKey = 0;
      this.chooseActiveKey = 0;
      this.modalType.keyVisible = false;
      this.isShowNext = true;
      this.modalType.fireBoxVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.question {
  position: relative;
  height: 100%;
  width: 100%;
}

.main-container {
  min-height: 100%;
  transition: margin-left 0.28s;
  margin-left: 0;
  position: relative;
  background: #f8f8f8;
}
.app-main {
  position: relative;
}
.container_full {
  // 全屏下
  width: 100vw !important;
  height: 100vh !important;
  margin: 0 auto !important;
  position: relative !important;
}
.container {
  .fullscreen {
    position: absolute;
    bottom: -3.125rem;
  }
  // 非全屏下
  width: 120rem;
  height: 67.5rem;
  margin: 0 auto;
  position: relative;
  // padding-bottom: 20px;
  .main-background {
    position: absolute;
    inset: 0 0 0 0;
    z-index: 0;
    overflow: hidden;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .title {
    height: 2.5rem;
    background-color: #409eff;
    line-height: 2.5rem;
    color: #fff;
    font-weight: 500;
    padding: 0 1.25rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    z-index: 8;
    left: 0;
    top: 0;
    width: 100%;
    font-size: 2rem;
    .ct {
      margin-left: auto;
    }
  }

  //   按钮
  .toolbar {
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 2.5rem;
    z-index: 9999;
  }
  .toolbar-content {
    margin: 0 12.5rem;
    .right-btn {
      margin-left: auto;
    }
    button {
      padding: 0.625rem 1.875rem;
      color: #fff;
      font-size: 16px;
      margin: 0 1.875rem;
      border-radius: 0.3125rem;
      cursor: pointer;
    }
  }

  .toolbar-content .btns,
  .toolbar-content .right-btn {
    display: flex;
    align-items: center;
  }
  .toolbar-content .btns {
    position: absolute;
    z-index: 9999;
    left: 6.25rem;
    right: 6.25rem;
    bottom: 0;
  }
}

.container .main .sub-title .progress,
.container .main .sub-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.toolbar-content .tips-content {
  width: 62.5rem;
  background-color: #fff;
  padding: 1.25rem;
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 2;
  border-radius: 0.3125rem;
  border: 0.3125rem solid #ccc;
}
/deep/ .el-dialog {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -ms-flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -ms-flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: calc(100% - 1.875rem);
  max-width: calc(100% - 1.875rem);
  background: transparent;
  -webkit-box-shadow: none;
  box-shadow: none;
  width: auto;
}
</style>